import { ProgramService } from '@modules/program/program-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import ManageModel from '@shared/manage/manage-model';

export default {
  namespaced: true,

  state: {
    loading: false,
    record: null,
  },

  getters: {
    record: (state) => state.record,
    loading: (state) => !!state.loading,
  },

  mutations: {
    FIND_STARTED(state) {
      state.record = null;
      state.loading = true;
    },

    FIND_SUCCESS(state, payload) {
      state.record = payload;
      state.loading = false;
    },

    FIND_ERROR(state) {
      state.record = null;
      state.loading = false;
    },
  },

  actions: {
    async doFind({ commit, rootGetters }, id) {
      try {
        commit('FIND_STARTED');
        
        const currentManage = rootGetters['auth/manage/currentManage'];
        const manageInput = new ManageModel(currentManage).getManageModel()
        const record = await ProgramService.find(id, manageInput);

        commit('FIND_SUCCESS', record);
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
        routerAsync().push('/program');
      }
    },
  },
};
